import { CareerCard } from '../types/careerCard';
import { createLogger } from '../utils/logger';

const logger = createLogger({ module: 'cardValidation' });

export const isValidCachedCard = (card: unknown): card is CareerCard => {
  if (!card || typeof card !== 'object') {
    logger.debug('Card validation failed: not an object');
    return false;
  }
  
  // Check essential top-level fields
  if (!('cardid' in card) || !('card_data' in card)) {
    logger.debug('Card validation failed: missing essential fields', { card });
    return false;
  }
  
  const cardData = (card as { card_data: Record<string, unknown> }).card_data;
  
  // Validate the card_data structure
  if (typeof cardData !== 'object' || cardData === null) {
    logger.debug('Card validation failed: card_data not an object');
    return false;
  }

  // Check for required fields in card_data
  const hasRequiredFields = 
    'title' in cardData &&
    'type' in cardData &&
    'custom_tags' in cardData &&
    'date_tags' in cardData;

  if (!hasRequiredFields) {
    logger.debug('Card validation failed: missing required fields in card_data', { cardData });
    return false;
  }

  // Validate arrays
  const hasValidArrays = 
    Array.isArray(cardData.custom_tags) &&
    Array.isArray(cardData.date_tags);

  if (!hasValidArrays) {
    logger.debug('Card validation failed: invalid arrays', { 
      custom_tags: cardData.custom_tags,
      date_tags: cardData.date_tags
    });
    return false;
  }

  return true;
}; 